var userAgent = require('../internals/engine-user-agent');

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/engine-is-ios.js
// module id = 166
// module chunks = 0 1